import { render, staticRenderFns } from "./EmployeeApprovers.vue?vue&type=template&id=05ddb03c&"
import script from "./EmployeeApprovers.vue?vue&type=script&lang=js&"
export * from "./EmployeeApprovers.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeApprovers.vue?vue&type=style&index=0&id=05ddb03c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports